export const LEADERBOARD_DATA = [
  { rank: 1, name: 'Alex M', score: 185, badge: 'Production Guardian', streak: 12, avatar: 'AM' },
  { rank: 2, name: 'Priya K', score: 172, badge: 'Incident Engineer', streak: 9, avatar: 'PK' },
  { rank: 3, name: 'Sam T', score: 160, badge: 'Incident Engineer', streak: 8, avatar: 'ST' },
  { rank: 4, name: 'Jordan L', score: 148, badge: 'Failure Analyst', streak: 6, avatar: 'JL' },
  { rank: 5, name: 'Morgan R', score: 135, badge: 'Failure Analyst', streak: 5, avatar: 'MR' },
  { rank: 6, name: 'Casey D', score: 120, badge: 'On-Call Warrior', streak: 4, avatar: 'CD' },
  { rank: 7, name: 'Riley P', score: 110, badge: 'On-Call Warrior', streak: 3, avatar: 'RP' },
  { rank: 8, name: 'Taylor W', score: 98, badge: 'Log Reader', streak: 2, avatar: 'TW' },
  { rank: 9, name: 'Quinn B', score: 87, badge: 'Log Reader', streak: 2, avatar: 'QB' },
  { rank: 10, name: 'Avery N', score: 75, badge: 'Rookie SRE', streak: 1, avatar: 'AN' },
];

export const BADGE_TIERS = [
  { name: 'Rookie SRE', minScore: 0 },
  { name: 'Log Reader', minScore: 50 },
  { name: 'On-Call Warrior', minScore: 100 },
  { name: 'Failure Analyst', minScore: 125 },
  { name: 'Incident Engineer', minScore: 150 },
  { name: 'Production Guardian', minScore: 175 },
];

export const AVATAR_GRADIENTS = [
  'from-amber-500 to-orange-600',
  'from-emerald-500 to-teal-600',
  'from-rose-500 to-pink-600',
  'from-violet-500 to-purple-600',
  'from-cyan-500 to-sky-600',
  'from-lime-500 to-green-600',
  'from-fuchsia-500 to-pink-600',
  'from-orange-500 to-red-600',
  'from-teal-500 to-cyan-600',
  'from-indigo-500 to-violet-600',
];
